import { createApi } from '@reduxjs/toolkit/query/react';

import { ILesson, IRating } from '@/interfaces/lesson';
import { API_BASE_URL } from '@/settings';

import { axiosBaseQuery } from './query';
import { resumeApi } from './resume';

export const lessonsApi = createApi({
  baseQuery: axiosBaseQuery(),
  reducerPath: 'lessonsApi',
  keepUnusedDataFor: 1000,
  tagTypes: ['rate'],
  endpoints(build) {
    return {
      manualWatchedLesson: build.mutation<IRating, { lessonId: string | undefined; watched: boolean }>({
        query: ({ lessonId, watched }) => ({
          method: 'PUT',
          formatResponse: response => response.data.data,
          url: `/learner/lessons/${lessonId}/manualWatchLesson`,
          data: {
            watched
          }
        }),
        async onQueryStarted({ lessonId }, { dispatch, queryFulfilled }) {
          try {
            await queryFulfilled;
            dispatch(
              lessonsApi.util.updateQueryData('getLessons', lessonId, draft => {
                Object.assign(draft, { watched: true });
              })
            );
            dispatch(resumeApi.util.invalidateTags(['getKeepWatchingShelf']));
          } catch {}
        }
      }),
      getRating: build.query<IRating, string | undefined>({
        query: lessonId => ({
          formatResponse: response => response.data.data,
          url: `/learner/lessons/${lessonId}/ratings`
        })
      }),
      saveRating: build.mutation<IRating, { lessonId: string | undefined; rating: number }>({
        query: ({ lessonId, rating }) => ({
          formatResponse: response => response.data.data,
          method: 'POST',
          url: `/learner/lessons/${lessonId}/ratings`,
          data: {
            rating
          }
        })
      }),
      getLessons: build.query<ILesson, string | undefined>({
        query: lessonId => ({
          formatResponse: response => ({
            ...response.data.data,
            ...response.data.data?.lesson
          }),
          url: `/learner/lessons/${lessonId}`,
          params: {
            forceManual: true
          }
        })
      }),
      downloadAudio: build.query<any, number>({
        query: contentId => ({
          baseURL: API_BASE_URL,
          formatResponse: response => response.data.data,
          url: `/download/audio/${contentId}`
        })
      })
    };
  }
});
export const { useGetLessonsQuery, useGetRatingQuery, useSaveRatingMutation, useManualWatchedLessonMutation } =
  lessonsApi;
